import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import { Panel } from '@watcherr/ui';
import ResidentFormContainer from '~/containers/Residents/ResidentForm';

const ResidentFormCreatePage = () => (
  <Panel>
    <ResidentFormContainer profile={null} />
  </Panel>
);

export default dashboardWrapper(ResidentFormCreatePage, t('residents.create.title'));
